import { EventInput } from '@fullcalendar/core';
import {
  getExternalEventResponseState,
  isExternalEventAllDay,
} from '@griply/utils';
import { ExternalCalendarEventExtendedProps } from 'shared/lib/full-calendar';
import { ExternalCalendarEvent } from 'shared/types/external-calendar-event';

export const mapExternalEventToFullCalendarEvent = (
  externalEvent: ExternalCalendarEvent,
  editable = false,
): EventInput => {
  // An optimistic create carries a local placeholder id the provider has never seen.
  // Withholding the calendar ref is what keeps it out of the popup, the context menu and
  // the drag path at once — every one of those resolves the event through that pair.
  const isPlaceholder = !!externalEvent.pending;
  const canEdit = editable && !isPlaceholder;

  return {
    id: externalEvent.id,
    title: externalEvent.title,
    // All-day events carry a `date`; their `end.date` is exclusive — exactly what
    // FullCalendar expects — so a multi-day event spans natively as one bar.
    // Timed events keep their `dateTime`s and FullCalendar slices multi-day ones
    // across the time-grid columns itself.
    allDay: isExternalEventAllDay(externalEvent),
    start:
      externalEvent.start.dateTime ?? externalEvent.start.date ?? undefined,
    end: externalEvent.end.dateTime ?? externalEvent.end.date ?? undefined,
    extendedProps: {
      externalId: externalEvent.id,
      url: isPlaceholder ? undefined : externalEvent.url,
      color: externalEvent.color,
      name: externalEvent.title,
      connectionId: isPlaceholder ? undefined : externalEvent.connectionId,
      calendarId: isPlaceholder ? undefined : externalEvent.calendarId,
      isRecurring: !!externalEvent.isRecurring,
      editable: canEdit,
      isOrganizer: isPlaceholder ? undefined : externalEvent.isOrganizer,
      responseState: getExternalEventResponseState(externalEvent),
    } satisfies ExternalCalendarEventExtendedProps,
    editable: canEdit,
  };
};
